import { privateTelemetryUrl, telemetryIsPrivate } from './telemetryPrivacy';
/** First-party, cookieless pageview counter. No cookies, no IP, no
 *  personal data — a random per-tab session id in sessionStorage only. */
const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

const sid = () => {
  try {
    let v = sessionStorage.getItem('ucw_sid');
    if (!v) {
      v = Math.random().toString(36).slice(2) + Date.now().toString(36);
      sessionStorage.setItem('ucw_sid', v);
    }
    return v;
  } catch { return 'anon-' + Date.now().toString(36); }
};

const utm = () => {
  try {
    const stored = sessionStorage.getItem('ucw_utm');
    if (stored) return JSON.parse(stored);
    const p = new URLSearchParams(window.location.search);
    const u = {};
    ['utm_source', 'utm_medium', 'utm_campaign'].forEach((k) => { const v = p.get(k); if (v) u[k] = v.slice(0, 60); });
    if (Object.keys(u).length) sessionStorage.setItem('ucw_utm', JSON.stringify(u));
    return u;
  } catch { return {}; }
};

export const trackPageview = (path) => {
  if (privateTelemetryUrl(path) || telemetryIsPrivate()) return;
  try {
    let ref;
    try { ref = document.referrer ? new URL(document.referrer).hostname : undefined; } catch { /* ignore */ }
    if (ref === window.location.hostname) ref = undefined;
    const payload = JSON.stringify({
      path,
      sid: sid(),
      ref,
      device: window.innerWidth < 768 ? 'mobile' : 'desktop',
      ...utm(),
    });
    const url = `${API_BASE}/metrics/pageview`;
    if (navigator.sendBeacon) {
      navigator.sendBeacon(url, new Blob([payload], { type: 'application/json' }));
    } else {
      fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: payload, keepalive: true }).catch(() => {});
    }
  } catch { /* metrics must never break the app */ }
};
